import React, {useState} from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../utils/variants";
import { transition } from "../../utils/transition";
import ReactPlayer from "react-player";
import Team from "../TeamMembers/Team";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

const WhoWeAre = () => {

    const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="relative min-h-screen bg-[#020617] text-slate-50">
      {/* Futuristic background layers */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.12] [background-image:linear-gradient(to_right,#0b1220_1px,transparent_1px),linear-gradient(to_bottom,#0b1220_1px,transparent_1px)] [background-size:46px_46px]" />
      <div className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-[#00ad0f]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-[#2563eb]/30 blur-3xl" />

      {/* HERO */}
      <section className="relative pt-28 md:pt-32 lg:pt-36 border-b border-white/10">
        <div className="relative mx-auto flex max-w-6xl flex-col px-5 pb-10 md:pb-14">
          <div className="mb-5 flex items-center justify-between text-[11px] uppercase tracking-[0.28em] text-slate-400">
            <span className="flex items-center gap-2">
              <span
                className="h-2 w-2 rounded-full shadow-[0_0_12px_rgba(34,197,94,0.8)]"
                style={{ background: BRAND.green }}
              />
              Scaftech Nigeria • Corporate Profile
            </span>
            <span className="hidden text-[10px] text-slate-500 sm:inline">
              Established 2020 • Engineering Excellence
            </span>
          </div>

          <div className="grid gap-8 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1.1fr)] md:items-center">
            {/* Text block */}
            <motion.div
              variants={fadeIn("Up")}
              transition={transition()}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="relative rounded-3xl border border-white/10 bg-[#020819]/90 p-6 shadow-[0_24px_80px_rgba(0,0,0,0.7)] backdrop-blur-xl md:p-8"
            >
              {/* Accent bar */}
              <div className="absolute inset-x-8 top-0 h-[3px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-white/40 to-[#062b6c]" />

              <p className="mb-2 text-[11px] uppercase tracking-[0.32em] text-slate-400">
                Who We Are
              </p>
              <h1 className="mb-3 text-3xl font-semibold uppercase text-slate-50 md:text-4xl lg:text-[2.6rem] lg:leading-tight">
                <span className="inline-block bg-gradient-to-r from-[#00ad0f] to-[#7fffb0] bg-clip-text text-transparent">
                  Redefining Engineering Standards
                </span>
              </h1>
              <p className="max-w-xl text-sm leading-relaxed text-slate-200 md:text-[0.98rem]">
                SCAFTECH Engineering Services is a pioneering firm co-founded by
                industry veterans with a vision to deliver innovative, efficient,
                and cost-effective engineering solutions that meet the highest
                safety and quality benchmarks across critical sectors.
              </p>

              {/* Key stats / meta */}
              <div className="mt-6 grid gap-3 text-[11px] md:grid-cols-3">
                <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 px-3 py-3">
                  <p className="uppercase tracking-[0.22em] text-emerald-300">
                    Since 2020
                  </p>
                  <p className="mt-1 text-xs text-emerald-100">
                    Built from field experience and driven by innovation.
                  </p>
                </div>
                <div className="rounded-2xl border border-sky-400/30 bg-sky-400/5 px-3 py-3">
                  <p className="uppercase tracking-[0.22em] text-sky-300">
                    Multi-Sector
                  </p>
                  <p className="mt-1 text-xs text-sky-100">
                    Oil &amp; Gas, Marine, Construction, Real Estate and more.
                  </p>
                </div>
                <div className="rounded-2xl border border-slate-500/40 bg-slate-800/60 px-3 py-3">
                  <p className="uppercase tracking-[0.22em] text-slate-300">
                    Core Values
                  </p>
                  <p className="mt-1 text-xs text-slate-200">
                    Technical excellence, customer focus, and ethical practice.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Image card – Who we are banner */}
            <motion.div
              variants={fadeIn("Up")}
              transition={transition()}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="relative h-56 overflow-hidden rounded-3xl border border-white/10 bg-slate-900/70 shadow-[0_24px_80px_rgba(0,0,0,0.8)] md:h-[320px]"
            >
              <img
                src="/new_img/inspection-2.jpg"
                alt="Scaftech inspection operations"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="pointer-events-none absolute inset-0 opacity-40 [background-image:linear-gradient(to_right,rgba(15,23,42,0.9)_1px,transparent_1px),linear-gradient(to_bottom,rgba(15,23,42,0.9)_1px,transparent_1px)] [background-size:32px_32px]" />

              <div className="absolute bottom-4 left-5 right-5 flex items-center justify-between text-[11px] text-slate-100">
                <div className="max-w-xs truncate">
                  <span className="block text-[10px] uppercase tracking-[0.26em] text-slate-400">
                    Scaftech Engineering Services
                  </span>
                  <span className="truncate text-sm">
                    Asset Integrity • Lifting • Training
                  </span>
                </div>
                <div className="flex flex-col items-end text-[10px] text-slate-300">
                  <span>Corporate View</span>
                  <span className="text-[9px] text-slate-500">
                    Lagos • Global Reach
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* STORY / HISTORY BLOCK */}
<motion.section
      variants={fadeIn("Up")}
      transition={transition()}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      className="relative py-10 md:py-14"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-5 md:px-0">
        <div className="relative rounded-3xl border border-slate-700/60 bg-slate-900/70 p-6 text-sm leading-[1.9] text-slate-100 shadow-[0_18px_60px_rgba(0,0,0,0.7)] backdrop-blur-xl md:p-8">
          {/* Always-visible brief summary */}
          <p>
            SCAFTECH Engineering Services is a pioneering engineering firm
            co-founded by industry veterans with a vision to redefine
            engineering standards. Our mission is to deliver innovative,
            efficient, and cost-effective engineering solutions that adhere to
            the highest safety and quality benchmarks.
          </p>

          <p className="mt-3">
            At SCAFTECH, our core values are centered around technical
            excellence, customer-centric service, and ethical business
            practices. We are committed to understanding and fulfilling our
            clients&apos; diverse needs with professionalism and precision.
            Our vision is to set new precedents in engineering excellence and
            responsible business conduct, fostering a culture of safety,
            sustainability, and continuous learning.
          </p>

          {/* Extra content only when expanded */}
          {isExpanded && (
            <>
              <p className="mt-3">
                Since its inception in 2020, SCAFTECH Engineering Services has
                been on a steadfast journey towards becoming a leader in the
                engineering sector. Founded by a team of seasoned professionals
                with a shared passion for engineering innovation, SCAFTECH
                started as a vision to bring advanced engineering solutions to
                diverse industries.
              </p>

              <p className="mt-3">
                In its early days, the company focused on establishing a strong
                foundation in scaffolding and fabrication services, quickly
                gaining recognition for its commitment to quality and safety.
                Over the years, SCAFTECH expanded its service offerings to
                include comprehensive engineering solutions, adapting to the
                evolving needs of the industry.
              </p>

              <p className="mt-3">
                A significant milestone in SCAFTECH&apos;s history was the
                introduction of its training and development programs, aimed at
                advancing the skills of both its team and clients in the
                engineering field. This move not only showcased SCAFTECH&apos;s
                dedication to continuous improvement but also solidified its
                position as a forward-thinking and responsible company.
              </p>

              <p className="mt-3">
                Another key achievement was the expansion of operations to
                include more specialized services like 3rd Party Statutory
                Inspection and Rooftop Fall Protection, aligning with the latest
                industry standards and client expectations. Throughout its
                journey, SCAFTECH has remained true to its core values of
                technical excellence, customer-centric service, and ethical
                business practices, paving the way for its ongoing success and
                growth in the competitive engineering landscape.
              </p>
            </>
          )}

          {/* Toggle button */}
          <button
            type="button"
            onClick={() => setIsExpanded((prev) => !prev)}
            className="mt-4 text-xs font-semibold uppercase tracking-[0.22em] text-emerald-300 hover:text-emerald-200"
          >
            {isExpanded ? "Show less" : "Read more"}
          </button>
        </div>
      </div>
    </motion.section>


      {/* TEAM SECTION */}
      <section className="relative border-t border-slate-800/80 bg-[#020617]">
        <Team />
      </section>

      {/* VIDEO + AWARDS */}
      <motion.section
        variants={fadeIn("Up")}
        transition={transition()}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
        className="relative"
      >
        <div className="mx-auto flex w-full max-w-5xl flex-col gap-10 px-5 py-10 md:flex-row md:px-0 md:py-16">
          {/* Video */}
          <div className="w-full overflow-hidden rounded-3xl border border-slate-700/60 bg-black/50 shadow-[0_18px_60px_rgba(0,0,0,0.8)]">
            <div className="aspect-video">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=E3odTnNeSA8"
                width="100%"
                height="100%"
              />
            </div>
          </div>

          {/* Text */}
          <div className="flex w-full flex-col gap-4 rounded-3xl border border-slate-700/60 bg-slate-900/70 p-6 shadow-[0_18px_60px_rgba(0,0,0,0.7)] backdrop-blur-xl md:p-8">
            <h2 className="text-2xl font-bold uppercase md:text-3xl">
              Our Awards and Certifications
            </h2>

            <p className="text-sm leading-relaxed text-slate-200 md:text-[0.98rem]">
              Scaftech provides world-class specialist Asset Integrity Assurance
              and Training services throughout the asset life-cycle. We service
              a wide range of markets including Oil and Gas, Marine,
              Construction, and Real Estate. With a broad range of services
              available through our multi-skilled workforce, we offer our
              clients integrated, effective solutions to their asset integrity
              challenges.
            </p>

            <p className="text-sm leading-relaxed text-slate-200 md:text-[0.98rem]">
              Our accreditations and professional memberships reflect our
              commitment to global standards, safety, and continuous
              improvement—positioning Scaftech as a trusted partner and a highly
              recognized training centre in the industry.
            </p>

            <div className="mt-2 self-start">
              <a
                href="/certification"
                className="group relative inline-flex h-11 items-center justify-center overflow-hidden rounded-full bg-[#082b6c] px-7 text-[11px] font-medium uppercase tracking-[0.22em] text-neutral-200 duration-500 hover:bg-[#2b9768]"
              >
                <div className="relative inline-flex items-center transition group-hover:-translate-x-4">
                  <div className="absolute -translate-y-0.5 translate-x-0 opacity-100 transition group-hover:-translate-x-4 group-hover:opacity-0">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                    >
                      <path
                        d="M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                  <span className="pl-5">View Accreditation &amp; Awards</span>
                  <div className="absolute right-0 translate-x-10 opacity-0 transition group-hover:translate-x-4 group-hover:opacity-100">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                    >
                      <path
                        d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z"
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </motion.section>

      {/* ACCREDITATIONS IMAGE STRIP */}
      <section className="relative">
        <div className="flex flex-col items-center gap-8 px-5 py-10 md:px-10 md:py-14">
          <div className="w-full text-center text-xl font-semibold leading-[1] text-slate-50 md:text-2xl">
            ACCREDITATION &amp; PROFESSIONAL
            <span className="why_choose_new_section_area_1_title_span">
              &nbsp; MEMBERSHIPS
            </span>
          </div>

          <div className="mx-auto w-full max-w-3xl rounded-3xl border border-slate-700/60 bg-slate-900/60 p-4 shadow-[0_18px_60px_rgba(0,0,0,0.7)]">
            <img
              src="/new_img/certification.png"
              alt="Scaftech accreditation and memberships"
              className="mx-auto h-auto w-full max-w-full object-contain"
            />
          </div>
        </div>
      </section>

    </div>
  );
};

export default WhoWeAre;
